import { render, staticRenderFns } from "./BlogComment.vue?vue&type=template&id=60722cc8&scoped=true"
import script from "./BlogComment.vue?vue&type=script&lang=js"
export * from "./BlogComment.vue?vue&type=script&lang=js"
import style0 from "./BlogComment.vue?vue&type=style&index=0&id=60722cc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60722cc8",
  null
  
)

export default component.exports